import { fields as addressFields } from "../../../Address/fields"
import { fields as financingConditions } from "../../../FinancingConditions/fields"
import { fields as leadFields } from "../../../Lead/fields"
import { fields as softleadFields } from "../../../Softlead/fields"

export const fields = {
  ...financingConditions,
  ...leadFields,
  ...addressFields,
  ...softleadFields
}
export const accordionData = [
  {
    title: "sobre o crédito",
    infoOrder: ["propertyUf", "financeObjective", "financeIof"],
    targetStep: "financingConditions",
    data: []
  },
  {
    title: "sobre você",
    infoOrder: [
      "birthdate",
      "nationality",
      "occupation_category",
      "occupation",
      "monthly_income",
      "marital_status",
      "partner_name",
      "partner_cpf",
      "partner_birthdate"
    ],
    targetStep: "lead",
    data: []
  },
  {
    title: "endereço residencial",
    infoOrder: [
      "street",
      "number",
      "complement",
      "neighborhood",
      "city",
      "state",
      "cep"
    ],
    targetStep: "address",
    data: []
  },
  {
    title: "dados de contato",
    infoOrder: ["name", "cpf", "email", "phone", "phone_2"],
    targetStep: "softlead",
    data: []
  },
  {
    id: "partnerShareIncome",
    title: "dados de quem irá compor renda",
    infoOrder: [
      "partner_name",
      "partner_cpf",
      "partner_birthdate",
      "partnerMaritalStatus",
      "partnerOccupationCategory",
      "partnerOccupation",
      "partnerMonthlyIncome"
    ],
    targetStep: "lead",
    data: []
  },
  {
    id: "partnerAddress",
    title: "endereço de quem irá compor renda",
    infoOrder: [
      "partnerStreet",
      "partnerNumber",
      "partnerComplement",
      "partnerNeighborhood",
      "partnerCity",
      "partnerState",
      "partnerCep"
    ],
    targetStep: "financingConditions",
    data: []
  },
  {
    id: "partnerContact",
    title: "contato de quem irá compor renda",
    infoOrder: ["partnerEmail", "partnerPhone1", "partnerPhone2"],
    targetStep: "softlead",
    data: []
  }
]

export const alternativeLabel = {
  partner_name: "nome completo de quem irá compor renda",
  partner_cpf: "CPF de quem irá compor renda",
  partner_birthdate: "data de nascimento de quem irá compor renda",
  cpf: "CPF"
}
